$(document).ready(function(){
    $(".block__game-changer-container").each(function(){
        var $this = $(this);
        $this.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            prevArrow: $this.parents(".block__game-changer-box").find(".block__game-changer-arrow-prev"),
            nextArrow: $this.parents(".block__game-changer-box").find(".block__game-changer-arrow-next"),
            fade: true,
            adaptiveHeight: true
        });
    });
});